module.exports = __webpack_public_path__ + "media/images/demo/m_site_template/0OP6MJJZ-1f881ee50b48b03ac95048a820bf4e58.png";